import { useTranslation } from 'react-i18next';
import { PropertySection } from './PropertySection';
import { PropertySectionText } from './PropertySectionText';
import { EventStatus } from '../../../types/eventStatus';
import { EventActionLog as EventActionLogType } from '../../../types/eventActionLog';
import { useLocalisedFormatDateTime } from '../../../utils/datetimeUtils';

type EventActionLogProps = {
  eventStatus: EventStatus;
  eventActionLog: EventActionLogType;
};

type PartialEventStatus = Extract<EventStatus, 'closed' | 'rejected' | 'cancelled'>;

const EventActionLog = (props: EventActionLogProps) => {
  const { t } = useTranslation();
  const formatDateTime = useLocalisedFormatDateTime();

  const statusTimestampTitleMap: Record<PartialEventStatus, string> = {
    cancelled: t('events.messages.canceledOn'),
    rejected: t('events.messages.rejectedOn'),
    closed: t('events.messages.closedEarlyOn'),
  };

  const statusReasonTitleMap: Record<PartialEventStatus, string> = {
    cancelled: t('events.messages.cancelationReason'),
    rejected: t('events.messages.rejectionReason'),
    closed: t('events.messages.closeReason'),
  };
  return (
    <>
      <PropertySection title={statusTimestampTitleMap[props.eventStatus as PartialEventStatus]}>
        <PropertySectionText>{`${formatDateTime(props.eventActionLog.action_timestamp)} by ${
          props.eventActionLog.user_name
        }`}</PropertySectionText>
      </PropertySection>
      <PropertySection title={statusReasonTitleMap[props.eventStatus as PartialEventStatus]}>
        <PropertySectionText>{props.eventActionLog.comment}</PropertySectionText>
      </PropertySection>
    </>
  );
};

export default EventActionLog;
